<template>
  <div id="app">
      <login-view v-if="!isLoggedIn"></login-view>
      <template v-if="isLoggedIn">
        <div id="toolbar-container">
            <toolbar id="main-toolbar"
                      v-on:open-forecast-clicked="openForecastLinkClicked"
                      v-on:my-points-clicked="myPointsLinkClicked"
                      v-on:settings-clicked="settingsLinkClicked" 
                      v-on:subscription-clicked="subscriptionLinkClicked"
                      v-on:logout-clicked="logOutLinkClicked"
                      v-on:forecast-info-clicked="forecastInfoClicked"
                      v-on:report-clicked="reportClicked"
                      v-on:summary-clicked="summaryClicked"
                      v-on:display-map-urls="displayMapUrlsClicked"
                      v-on:about-clicked="showAboutBox"/>
          </div>          
        <div id="root-content-container" v-if="isLoggedIn">          
          <div class="map-viewer-container" id="map-viewer-container-1">
            <map-viewer ref="mapViewer1"/>
          </div>
          <div class="map-viewer-container" id="main-viewer-container-2" v-if="$store.state.appSettings.dualPane">
            <map-viewer ref="mapViewer2"/>
          </div>          
        </div>
        <div class="root-data-panel-container">
          <report-container class="data-panel" ref="reportContainer" :style="{ top: $store.state.toolbarHeight + 'px' }" ></report-container>
          <summary-container class="data-panel" ref="summaryContainer" :style="{ top: $store.state.toolbarHeight + 'px' }" ></summary-container>
        </div>
      </template>      
      <select-forecast-dialog ref="selectForecastDialog"></select-forecast-dialog>
      <select-variable-dialog ref="selectVariableDialog"></select-variable-dialog>
      <settings-dialog ref="settingsDialog"></settings-dialog>
      <subscription-dialog ref="subscriptionDialog"></subscription-dialog>
      <add-point-dialog ref="addPointDialog"></add-point-dialog>
      <edit-point-dialog ref="editPointDialog"></edit-point-dialog>
      <forecast-info-dialog ref="forecastInfoDialog"></forecast-info-dialog>
      <prompt-dialog ref="promptDialog"></prompt-dialog>
      <manage-points-dialog ref="managePointsDialog"></manage-points-dialog>      
      <about-box-dialog ref="aboutBoxDialog"></about-box-dialog>
  </div>
</template>

<script>
import Toolbar from '@/components/Toolbar.vue'
import SelectForecastDialog from '@/components/SelectForecastDialog.vue'
import MapViewer from '@/components/MapViewer.vue'
import SelectVariableDialog from '@/components/SelectVariableDialog.vue'
import SettingsDialog from '@/components/SettingsDialog.vue'
import SubscriptionDialog from '@/components/SubscriptionDialog.vue'
import AddPointDialog from '@/components/AddPointDialog.vue'
import EditPointDialog from '@/components/EditPointDialog.vue'
import ForecastInfoDialog from '@/components/ForecastInfoDialog.vue'
import PromptDialog from '@/components/PromptDialog.vue'
import ManagePointsDialog from '@/components/ManagePointsDialog.vue'
import LoginView from '@/components/LoginView.vue'
import ReportContainer from '@/components/ReportContainer.vue'
import SummaryContainer from '@/components/SummaryContainer.vue'
import AboutBoxDialog from '@/components/AboutBoxDialog.vue'

import config from '@/lib/config.js'
import events from '@/lib/events.js'
import { ServiceController } from '@/lib/ServiceController.js'
import logger from '@/lib/logger.js'
import UserData from '@/lib/UserData.js'
import $ from '@/lib/JQuery.js'

import { SampleReportData } from '@/lib/SampleData.js'

//import recordsetTests from '@/lib/tests/RecordsetTests.js'

export default {
  components: { 
    Toolbar, 
    SelectForecastDialog, 
    MapViewer, 
    SelectVariableDialog,
    SettingsDialog,
    SubscriptionDialog,
    AddPointDialog,
    ForecastInfoDialog,
    PromptDialog,
    ManagePointsDialog,
    LoginView,
    ReportContainer,
    SummaryContainer,
    EditPointDialog,
    AboutBoxDialog
  },  
  computed: {
    isLoggedIn() {
      return this.$store.state.user != null
    },
  },
  methods: {
    displayMapUrlsClicked() {
      var urlLeft = this.$refs.mapViewer1.getCurrentImageLayerUrl()
      var urlRight = this.$refs.mapViewer2.getCurrentImageLayerUrl()

      if (urlLeft == '') 
        urlLeft = 'No image open'
      if (urlRight == '')
        urlRight = 'No image open'
      
      alert('Left: ' + urlLeft + '\nRight: ' + urlRight)
    },
    openAutoLoadForecast(cid) {
      logger.log('App::openAutoLoadForecast()')
      
      var inventoryItem = this.$store.state.forecastInventory.items.find((item) => item.country.countryID == cid)
      if (!inventoryItem)
        return false
      
      var forecast = inventoryItem.forecasts[0]
      if (forecast == null)
        return false
      
      logger.log('Auto load forecast', { cid: cid, forecast: forecast })

      this.$store.commit('setForecast', forecast)

      return true
    },
    openForecastLinkClicked() {
      logger.log('App::openForecastLinkClicked()')      
      this.$refs.selectForecastDialog.show()
    },
    handleOpenForecastEvent() {
      logger.log('App::handleOpenForecastEvent()')
      if (!this.$store.state.forecastInventory)
        return
      if (this.$store.state.userConfig.autoLoadCID) {
        if (this.openAutoLoadForecast(this.$store.state.userConfig.autoLoadCID))
          return
      }
      this.$refs.selectForecastDialog.show()
    },
    myPointsLinkClicked() {
      logger.log('App::myPointsLinkClicked()')
    },
    settingsLinkClicked() {
      logger.log('App::settingsLinkClicked()')
      this.$refs.settingsDialog.show()
    },
    subscriptionLinkClicked() {
      logger.log('App::subscriptionLinkClicked()')
      this.$refs.subscriptionDialog.show()
    },
    logOutLinkClicked() {
      logger.log('App::logOutLinkClicked()')
      ServiceController.logout()      
    },
    forecastInfoClicked() {
      logger.log('App::forecastInfoClicked')
      this.$refs.forecastInfoDialog.show()
    },
    openVariableClicked(sender) {
      logger.log('App::openVariableClicked())')
      this.$refs.selectVariableDialog.show(sender)
    },
    summaryClicked() {
      logger.log('App::summaryClicked()')    
      
      this.$refs.summaryContainer.openSummary(this.$store.state.forecastVarInventory)
    },
    reportClicked() {
      logger.log('App::reportClicked()')

      this.$refs.reportContainer.openReport()      
    },
    addPointClicked(lat, lon, name) {
      logger.log('App::addPointClicked', { lat: lat, lon: lon, name: name })
      this.$refs.addPointDialog.setServiceController(ServiceController)
      this.$refs.addPointDialog.show(lat, lon, name)
    },
    editPointClicked(lat, lon, name, pointID) {
      logger.log('App::editPointClicked', { lat: lat, lon: lon, name: name, pointID: pointID })
      this.$refs.editPointDialog.setServiceController(ServiceController)
      this.$refs.editPointDialog.show(lat, lon, name, pointID)
    },
    managePointsClicked() {
      this.$refs.managePointsDialog.show()
    },
    installTestUser() {
      setTimeout(() => {        
        this.$store.commit('setUser', new UserData('aaa', 'Test User', 'test@test.com', 'Test Plan', 9))
      }, 1000)      
    },
    showError(error) {
      logger.log('Error received: ' + error)
      alert(error)
    },
    displayPrompt(title, message, buttons, handler) {
      logger.log('App::displayPrompt()')
      this.$refs.promptDialog.show(title, message, buttons, handler)
    },    
    showAboutBox() {
      this.$refs.aboutBoxDialog.open()
    }
  },
  mounted() {
    events.$on(events.EVT_ERROR, (error) => this.showError(error))
    events.$on(events.ACTION_OPEN_VARIABLE, (sender) => this.openVariableClicked(sender))
    events.$on(events.ACTION_ADD_POINT, (lat, lon, name) => this.addPointClicked(lat, lon, name))
    events.$on(events.ACTION_EDIT_POINT, (lat, lon, name, pointID) => this.editPointClicked(lat, lon, name, pointID))
    events.$on(events.ACTION_PROMPT, (title, message, buttons, handler) => this.displayPrompt(title, message, buttons, handler))
    events.$on(events.ACTION_MANAGE_POINTS, () => this.managePointsClicked())
    events.$on(events.ACTION_OPEN_FORECAST, () => this.handleOpenForecastEvent())

    ServiceController.init(this.$store)    

    let width = window.innerWidth || 0
    if (width != 0)
      if (width < config.dualPaneThreshold)
        this.$store.state.appSettings.dualPane = false          
  },
  created() {
    /*if (config.runTests) {
      setTimeout(() => {
        console.clear()
        recordsetTests.runAll()
      }, 1000)      
    }*/
  }
}
</script>

<style>

.modal-backdrop {
  z-index: 1500;
}
.modal {
  z-index: 1501;
}

#app {
    /*display: flex;*/
    flex-direction: column;
    width: 100%;
    height: 100%;
}

#root-content-container {
  /*flex: 1;*/
  display: flex;
  background-color: #f8f9fa;
  background: linear-gradient( #f8f9fa,  #c4cdd6 );
  /*position: relative;*/
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}

#main-toolbar {
  z-index: 1000;
  background-color: rgba(255, 255, 255, 0.85) !important;
}

.map-viewer-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.root-data-panel-container {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  pointer-events: none;
}

.root-data-panel-container > * {
  pointer-events: all;
}

</style>